import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../../components/Login';
import Register from '../../components/Register';
import { auth } from '../../firebaseconfig';
import '../../views/styles/Homepage.css';

function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        navigate('/profile');
      }
    });
    return unsubscribe;
  }, [navigate]);

  return (
    <div className="homepage-container">
      <div className="homepage-inner-container">
        <h1 className="homepage-header">Velkommen til SafeByte</h1>
        <p className="homepage-subtext">
          Hold din mad sikker baseret på dine allergi-præferencer.
        </p>

        <div className="auth-section">
          <div className="auth-card">
            <h2 className="auth-title">Log ind</h2>
            <p className="homepage-subtext">
            Har du været her før? Log ind for at fortsætte.
           </p>
            <Login />
          </div>
          <div className="auth-card">
            <h2 className="auth-title">Opret konto</h2>
            <p className="homepage-subtext">
              Ny her? Opret en konto for at komme i gang.
            </p>
            <Register />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
